import { getAuth, onAuthStateChanged } from "firebase/auth";

export function waitForFirebaseUser(timeoutMs = 10000) {
  const auth = getAuth();

  return new Promise((resolve, reject) => {
    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }

    const timeout = setTimeout(() => {
      unsubscribe();
      reject(new Error("Firebase user load timeout."));
    }, timeoutMs);

    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        clearTimeout(timeout);
        unsubscribe();
        if (user) {
          resolve(user);
        } else {
          reject(new Error("User is not authenticated."));
        }
      },
      (error) => {
        clearTimeout(timeout);
        unsubscribe();
        reject(error);
      }
    );
  });
}